import { buildStateRequestStatus, buildBasicState } from '@/helpers/store';
import requestStatusKeys from './_requestStatusKeys';
import basicKeys from './_basicKeys';

export default {
    ...buildStateRequestStatus(requestStatusKeys),
    ...buildBasicState(basicKeys),
    originacoesListTotalPages: 0,
};
